import React from "react";
import { useManagerEntitlement } from "@src/queries/managerConfigurationQueries";
import { ManagerEntitlement } from "@src/types/managerConfiguration";
import NoPermissionPage from "@src/pages/NoPermission/NoPermissionPage";

type ManagerEntitlementRouteProps = {
  entitlement: ManagerEntitlement;
  children: React.ReactNode;
};

/**
 * Shows a manager whose configuration leaves `entitlement` out the "no
 * permission" page, so a hidden tab can't be reached by its URL either. Admins and curators pass
 * straight through — see `useManagerEntitlement`.
 */
const ManagerEntitlementRoute: React.FC<ManagerEntitlementRouteProps> = ({
  entitlement,
  children,
}) => {
  const isEntitled = useManagerEntitlement(entitlement);
  return isEntitled ? <>{children}</> : <NoPermissionPage />;
};

export default ManagerEntitlementRoute;
